/**
 * Hook simplifié pour les notifications
 * Ré-exporte useUnifiedNotifications pour compatibilité
 */
import { useUnifiedNotifications } from './useUnifiedNotifications';

export const useNotifications = () => {
  const unified = useUnifiedNotifications();

  return {
    notifications: unified.notifications ?? [],
    unreadCount: unified.unreadCount ?? 0,
    markAllAsRead: unified.markAllAsRead ?? (() => {}),
    markAsRead: unified.markAsRead ?? (() => {}),
    connectionStatus: unified.connectionStatus ?? 'disconnected',
  };
};

export default useNotifications;
